import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyComponent } from './company.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth.guard';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { CompanyListComponent } from './company-list/company-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { BlockUIModule } from 'ng-block-ui';
import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { FormsModule } from '@angular/forms';
import { CompanyCreateComponent } from './company-create/company-create.component';
import { NgxMaskModule } from 'ngx-mask';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { FileuploadModule } from 'app/services/common/fileupload/fileupload.module';
import { CompanyDetailPersonListComponent } from './company-detail/company-detail-person-list/company-detail-person-list.component';
import { CompanyDetailRequestTaskListComponent } from './company-detail/company-detail-request-task-list/company-detail-request-task-list.component';
import { CompanyDetailTransactionListComponent } from './company-detail/company-detail-transaction-list/company-detail-transaction-list.component';
import { CompanyDetailVaultMovementsComponent } from './company-detail/company-detail-vault-movements/company-detail-vault-movements.component';
import { CompanyDetailDeviceListComponent } from './company-detail/company-detail-device-list/company-detail-device-list.component';

const routes: Routes = [
  {
    path: 'company',
    component: CompanyComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
  {
    path: 'company/:id',
    component: CompanyDetailComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
  {
    path: 'company-create',
    component: CompanyCreateComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
];

@NgModule({
  declarations: [
    CompanyComponent,
    CompanyListComponent,
    CompanyDetailComponent,
    CompanyCreateComponent,
    CompanyDetailPersonListComponent,
    CompanyDetailRequestTaskListComponent,
    CompanyDetailTransactionListComponent,
    CompanyDetailVaultMovementsComponent,
    CompanyDetailDeviceListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ContentHeaderModule,
    NgxDatatableModule,
    NgbModule,
    NgSelectModule,
    CoreCommonModule,
    BlockUIModule,
    FormsModule,
    CoreDirectivesModule,
    NgxMaskModule.forRoot(),
    FileuploadModule
  ],
})
export class CompanyModule { }
